/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/modules/pricing/pricingModel', 'assets/js/modules/utils'], function(PricingModel, utils) {
    return PricingModel.extend(
        {
            defaults: {
                strategy: 'percentage_sub',
                percentage: 0,
                basedOn: 'required_option_price'
            },
            /**
             * @param {Object} context
             * @returns {number}
             */
            getPrice: function(context) {
                if (context.requiredOptionPrice === undefined) {
                    return 0;
                }

                const optionBasePrice = context.requiredOptionPrice;

                return utils.roundFloat(utils.multiplication(optionBasePrice, this.get('percentage')));
            },

            toString: function(context) {
                return '';
            }
        },
        {
            BASED_ON_REQUIRED_OPTION_PRICE: 'required_option_price'
        }
    );
});
